export default "__VITE_ASSET__CWmS$asZ__"